import request from './request'

export function login(data) {
    return request({
        url: '/login',
        method: 'post',
        data
    })
}

export function info(data) {
    return request({
        url: '/info',
        method: 'post',
        data
    })
}
